import { render, staticRenderFns } from "./channelSearchBar.vue?vue&type=template&id=210e321f&scoped=true"
import script from "./channelSearchBar.vue?vue&type=script&lang=js"
export * from "./channelSearchBar.vue?vue&type=script&lang=js"
import style0 from "./channelSearchBar.vue?vue&type=style&index=0&id=210e321f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210e321f",
  null
  
)

export default component.exports